module.exports = __webpack_public_path__ + "static/media/intern_logo.bb749414.svg";